import { CREATE_ANNOUNCEMENTS_LOADING, CREATE_ANNOUNCEMENTS_SUCCESS, CREATE_ANNOUNCEMENTS_ERROR } from "../../../constant/actionTypes";

const createAnnouncementReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_ANNOUNCEMENTS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_ANNOUNCEMENTS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case CREATE_ANNOUNCEMENTS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createAnnouncementReducer;